// extracted by mini-css-extract-plugin
export default {"ellipsis":"BLParagraph_ellipsis__+1aG7","text-ellipsis":"BLParagraph_text-ellipsis__VK9VQ"};